import { useState } from 'react'
import { message as $message } from 'antd'
import { queryHasDistributionGoodsData } from '@/services/distribute/myDistributeMall'

export default () => {
    const [hasDistributionData, setHasDistributionData] = useState(0)
    const [isInitHasDistributionData, setIsInitHasDistributionData] = useState(false)
    const [fetchHasDistributionDataLoading, setFetchHasDistributionDataLoading] = useState(false)

    const fetchHasDistributionData = async () => {
        setFetchHasDistributionDataLoading(true)

        try {
            const { success, message, data } = await queryHasDistributionGoodsData()

            if (success) {
                setHasDistributionData(data)
                setIsInitHasDistributionData(true)
            } else {
                $message.error(message)
            }
        } catch (e) {
            console.error('catchError', e)
        }

        setFetchHasDistributionDataLoading(false)
    }

    return {
        isInitHasDistributionData,
        fetchHasDistributionDataLoading,
        hasDistributionData,
        fetchHasDistributionData
    }
}
